import MultiPose from './MultiPose';

export default MultiPose;
